<template>
  <div class="profile">
    <div class="dashboard-container">
      <validation-observer ref="form">
          <div class="profile-info d-flex flex-column flex-md-row align-items-md-center justify-content-between">
            <div class="left d-flex align-items-center">
              <div class="avatar">
                <svg width="41" height="42" viewBox="0 0 41 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd"
                        d="M40.694 21C40.694 32.0818 31.7001 41.0758 20.6182 41.0758C9.53642 41.0758 0.54248 32.0818 0.54248 21C0.54248 9.91818 9.53642 0.92424 20.6182 0.92424C31.7001 0.92424 40.694 9.91818 40.694 21ZM14.5955 25.517C15.9807 25.517 17.105 24.3928 17.105 23.0076C17.105 21.6223 15.9807 20.4981 14.5955 20.4981C13.2103 20.4981 12.086 21.6223 12.086 23.0076C12.086 24.3928 13.2103 25.517 14.5955 25.517ZM24.1315 23.0076C24.1315 21.6223 25.2557 20.4981 26.641 20.4981C28.0262 20.4981 29.1504 21.6223 29.1504 23.0076C29.1504 24.3928 28.0262 25.517 26.641 25.517C25.2557 25.517 24.1315 24.3928 24.1315 23.0076ZM31.6599 12.9697C25.8379 12.9697 20.7387 9.83788 17.9281 5.1803C18.7913 5.03977 19.6948 4.93939 20.6182 4.93939C26.4402 4.93939 31.5395 8.07121 34.3501 12.7288C33.4868 12.8693 32.5834 12.9697 31.6599 12.9697ZM5.40081 15.9208C8.83377 13.9735 11.4838 10.8015 12.7485 7.00719C9.31559 8.95454 6.66559 12.1265 5.40081 15.9208ZM36.0163 16.503C36.4379 17.9284 36.6788 19.4341 36.6788 21C36.6788 29.8534 29.4716 37.0606 20.6182 37.0606C11.7648 37.0606 4.55763 29.8534 4.55763 21C4.55763 20.9658 4.55997 20.9315 4.56225 20.8981C4.56666 20.8335 4.57086 20.7718 4.55763 20.7189C9.77733 18.7515 13.9732 14.7163 16.0811 9.57689C19.7751 14.0939 25.3762 16.9848 31.6599 16.9848C33.1656 16.9848 34.611 16.8042 36.0163 16.503Z"
                        fill="black" />
                </svg>
              </div>
              <div class="user-info">
                <h4>{{ $auth.user().email }}</h4>
                <p>Profile created : {{ $auth.user().date_joined|formatDate }}</p>
              </div>
            </div>
            <div class="right">
              <p>Email</p>
              <div>
                <div class="input-container">
                  <input type="email" :value="$auth.user().email" placeholder="your email" readonly />
                  <svg width="31" height="30" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect x="1.11816" y="0.5" width="29" height="29" rx="14.5" fill="#1FDB4F" stroke="#108E30" />
                    <path
                        d="M13.8183 20.7L9.21826 16.1L11.2183 14.2L13.8183 16.8L21.2183 9.4L23.2183 11.4L13.8183 20.7Z"
                        fill="white" />
                  </svg>
                </div>
                <button class="main-btn" @click="changePassword = !changePassword">Change Password</button>
              </div>
            </div>
          </div>
          <div class="change-password box-style mt-5" :style="{'display': changePassword ? 'block' : 'none'}">
            <h3 class="title">Change Password</h3>
            <div class="change-password-content">
              <form class="change-password-form">
                <div class="row align-items-end">
                  <div class="col-md-6 col-xl-3">
                    <div class="form-group">
                      <label for="currentPassword">Current Password</label>
                      <div class="current-pwd-container">
                        <input :type="form.passwordVisible ? 'text' : 'password'" v-model="form.passwordCurrent" id="currentPassword" value="123456"
                               class="input-current-password form-control" placeholder="Current password" />
                        <span class="eye" id="eye" @click="form.passwordVisible = !form.passwordVisible">
                          <svg width="27" height="26" viewBox="0 0 27 26" fill="none"
                               xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                  d="M5.74385 7.07924L2.92917 4.26456L4.41003 2.77319L23.0311 21.4047L21.5502 22.8856L17.9583 19.2937C16.551 19.8504 15.0176 20.1549 13.4212 20.1549C8.16995 20.1549 3.68535 16.8886 1.86841 12.278C2.67711 10.209 4.03194 8.42357 5.74385 7.07924ZM13.4212 6.5016C17.4017 6.5016 20.9516 8.73865 22.6845 12.278C22.0648 13.5593 21.1931 14.6621 20.1534 15.5548L21.6342 17.0357C23.0941 15.7439 24.2494 14.1265 24.974 12.278C23.1571 7.66739 18.6725 4.40109 13.4212 4.40109C12.0874 4.40109 10.8061 4.61114 9.5983 4.99974L11.3312 6.73266C12.0139 6.59613 12.7071 6.5016 13.4212 6.5016ZM12.2975 7.6989L14.4715 9.87293C15.0701 10.1355 15.5532 10.6186 15.8158 11.2173L17.9898 13.3913C18.0739 13.0342 18.1369 12.6561 18.1369 12.2675C18.1474 9.66288 16.0259 7.55186 13.4212 7.55186C13.0326 7.55186 12.665 7.60437 12.2975 7.6989ZM10.8061 12.1415L13.5473 14.8826C13.5052 14.8932 13.4632 14.9037 13.4212 14.9037C11.9719 14.9037 10.7956 13.7274 10.7956 12.278C10.7956 12.2518 10.7982 12.2308 10.8008 12.2097C10.8035 12.1887 10.8061 12.1677 10.8061 12.1415ZM9.07317 10.4086L7.23522 8.57061C5.96441 9.53684 4.89315 10.7761 4.15797 12.278C5.89089 15.8174 9.44076 18.0544 13.4212 18.0544C14.419 18.0544 15.3852 17.9074 16.3094 17.6553L15.2802 16.6261C14.713 16.8676 14.0829 17.0042 13.4212 17.0042C10.8166 17.0042 8.69507 14.8826 8.69507 12.278C8.69507 11.6164 8.83161 10.9862 9.07317 10.4086Z"
                                  fill="black" />
                          </svg>
                        </span>
                      </div>
                    </div>
                    <validation-provider name="password" v-slot="{ errors }">
                      <div class="invalid-feedback" style="display: block">{{ errors[0] }}</div>
                    </validation-provider>
                  </div>
                  <div class="col-md-6 col-xl-3">
                    <div class="form-group new-password">
                      <label for="new-password">New Password</label>
                      <input :type="form.passwordVisible ? 'text' : 'password'" v-model="form.password" id="new-password" class="input-password form-control"
                             placeholder="New Password" />
                    </div>
                    <validation-provider name="new_password" v-slot="{ errors }">
                      <div class="invalid-feedback" style="display: block">{{ errors[0] }}</div>
                    </validation-provider>
                  </div>
                  <div class="col-md-6 col-xl-3">
                    <div class="form-group confirm-password">
                      <label for="confirm-password">Confirm New Password</label>
                      <input :type="form.passwordVisible ? 'text' : 'password'" v-model="form.passwordConfirmation" id="confirm-password" class="input-confirm-password form-control"
                             placeholder="Confirm New Password" />
                    </div>
                  </div>
                  <div class="col-md-6 col-xl-3 last">
                    <div class="form-group d-flex justify-content-end">
                      <button class="main-btn save_password" id="save-password" type="button" @click="updatePassword" :disabled="!passwordValid">Save New
                        Password</button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="notifications box-style">
            <h3>Notifications</h3>
            <div class="checkboxes d-md-flex align-items-center justify-content-between">
              <div class="form-check">
                <input type="checkbox" class="form-check-input" v-model="form.notifications" value="withdraw" name="withdraw" id="withdraw" />
                <label class="form-check-label" for="withdraw">Withdraw Activity</label>
              </div>
              <div class="form-check">
                <input type="checkbox" class="form-check-input" v-model="form.notifications" value="weekly_report" name="weekly-report" id="weekly-report" />
                <label class="form-check-label" for="weekly-report">Weekly Report</label>
              </div>
              <div class="form-check">
                <input type="checkbox" class="form-check-input" v-model="form.notifications" value="password_change" name="password-change" id="password-change"
                       checked />
                <label class="form-check-label" for="password-change">Password change</label>
              </div>
              <div class="form-check">
                <input type="checkbox" class="form-check-input" v-model="form.notifications" value="news" name="press-updates" id="press-updates" />
                <label class="form-check-label" for="press-updates">Press updates</label>
              </div>
              <div class="form-check change-password form-group">
                <button class="main-btn save_password" type="submit" @click="updateNotifications">Update Settings</button>
              </div>
            </div>
          </div>
          <div class="payment">
            <div class="row">
              <div class="col-xl-5 d-flex">
                <div class="payment-options w-100">
                  <h3>Payment Options</h3>
                  <div class="paypal-payment payment--method">
                    <div class="pay-card form-check">
                      <input type="radio" v-model="form.payout" class="form-check-input" value="paypal" name="payout" id="paypal" />
                      <label class="label-radio form-check-label" for="paypal">PayPal</label>
                    </div>
                  </div>
                  <div class="card-info paypal-info" v-show="form.payout === 'paypal'">
                    <p>Paypal Address</p>
                    <div class="email d-md-flex justify-content-between">
                      <input type="text" v-model="form.payout_paypal" name="paypal-email" placeholder="PayPal Email"/>
                      <button class="main-btn" @click="updatePayment">Save</button>
                    </div>
                    <validation-provider name="payout_paypal" v-slot="{ errors }">
                      <div class="invalid-feedback" style="display: block">{{ errors[0] }}</div>
                    </validation-provider>
                  </div>
                  <div class="bitcoin-payment payment--method">
                    <div class="pay-card form-check">
                      <input type="radio" v-model="form.payout" value="bitcoin" class="form-check-input" placeholder="BTC Wallet" name="payout" id="bitcoin" />
                      <label class="label-radio form-check-label" for="bitcoin">Bitcoin Wallet </label>
                    </div>
                  </div>
                  <div class="card-info paypal-info" v-show="form.payout === 'bitcoin'">
                    <p>Bitcoind Wallet</p>
                    <div class="email d-md-flex justify-content-between">
                      <input type="text" v-model="form.payout_bitcoin" name="paypal-email"/>
                      <button class="main-btn" @click="updatePayment">Save</button>
                    </div>
                    <validation-provider name="payout_bitcoin" v-slot="{ errors }">
                      <div class="invalid-feedback" style="display: block">{{ errors[0] }}</div>
                    </validation-provider>
                  </div>
                  <div class="usdt-payment payment--method">
                    <div class="pay-card form-check">
                      <input type="radio" class="form-check-input" v-model="form.payout" value="usdt" placeholder="TRC20 Wallet" name="payout" id="usdt" />
                      <label class="label-radio form-check-label" for="usdt">USDT TRC20 </label>
                    </div>
                  </div>
                  <div class="card-info paypal-info" v-show="form.payout === 'usdt'">
                    <p>USDT TRC20 Adress</p>
                    <div class="email d-md-flex justify-content-between">
                      <input type="text" v-model="form.payout_usdt" name="paypal-email" id="paypal-email"/>
                      <button class="main-btn" @click="updatePayment">Save</button>
                    </div>
                  </div>
                  <validation-provider name="payout_usdt" v-slot="{ errors }">
                    <div class="invalid-feedback" style="display: block">{{ errors[0] }}</div>
                  </validation-provider>
                </div>
              </div>
            </div>
          </div>
      </validation-observer>
    </div>
  </div>
</template>

<script>

import API from "@/api"
const api = new API()
export default {
  name: "Profile",
  data() {
    return {
      form: {
        passwordVisible: false,
        password: '',
        passwordConfirmation: '',
        passwordCurrent: '',
        notifications: [],
        payout: 'paypal',
        payout_paypal: '',
        payout_bitcoin: '',
        payout_usdt: ''
      },
      changePassword: false
    }
  },
  mounted() {
    this.form.payout = 'paypal'

    const notifications = []
    if (this.$auth.user().notifications_withdraw) {
      notifications.push('withdraw')
    }

    if (this.$auth.user().notifications_weekly_report) {
      notifications.push('weekly_report')
    }

    if (this.$auth.user().notifications_password_change) {
      notifications.push('password_change')
    }

    if (this.$auth.user().notifications_news) {
      notifications.push('news')
    }

    this.form.notifications = notifications

    this.form.payout_paypal = this.$auth.user().payout_paypal
    this.form.payout_bitcoin = this.$auth.user().payout_bitcoin
    this.form.payout_usdt = this.$auth.user().payout_usdt
  },
  computed: {
    passwordValid() {
      return this.form.passwordCurrent.length >= 5 && this.form.password.length >= 5 && this.form.password === this.form.passwordConfirmation
    }
  },
  methods: {
    updatePassword() {
      this.$refs.form.reset()

      this.$wait.start('password_update')
      api.updatePassword(this.form.passwordCurrent, this.form.password)
          .then(r => this.$auth.user(r.data))
          .catch(r => this.$refs.form.setErrors(r.response.data))
          .finally(() => this.$wait.end('password_update'))
    },
    updateNotifications() {
      this.$refs.form.reset()

      const notifications = {
        notifications_withdraw: this.form.notifications.includes('withdraw'),
        notifications_weekly_report: this.form.notifications.includes('weekly_report'),
        notifications_password_change: this.form.notifications.includes('password_change'),
        notifications_news: this.form.notifications.includes('news')
      }

      this.$wait.start('notification_update')
      api.updateNotifications(notifications)
        .then(r => this.$auth.user(r.data))
        .catch(r => this.$refs.form.setErrors(r.response.data))
        .finally(() => this.$wait.end('notification_update'))
    },
    updatePayment() {
      this.$refs.form.reset()

      this.$wait.start('payment_update')
      let data = {}
      switch (this.form.payout) {
        case 'paypal':
          data = {payout_paypal: this.form.payout_paypal}
          break
        case 'bitcoin':
          data = {payout_bitcoin: this.form.payout_bitcoin}
          break
        case 'usdt':
          data = {payout_usdt: this.form.payout_usdt}
          break
      }

      api.updatePayment(data)
        .then(r => this.$auth.user(r.data))
        .catch(r => this.$refs.form.setErrors(r.response.data))
        .finally(() => this.$wait.end('payment_update'))
    }
  }
}
</script>

<style scoped>

</style>